<template>
    <div class="step">
        <el-steps :active="$store.getters.demAct" simple>
            <el-step title="上传模型"></el-step>
            <el-step title="选择打印机"></el-step>
            <el-step title="选择耗材"></el-step>
            <el-step title="选择物流"></el-step>
            <el-step title="交付方案"></el-step>
        </el-steps>
    </div>
</template>

<script>
    export default {
        name: 'DemandTitle',
    }
</script>

<style lang="scss" scoped>
.step{
    width: 14.5rem;
}
</style>